import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12 6c-.404 0-.5.175-.91.585l-3.69 3.64a.979.979 0 00-.377.999.993.993 0 00.764.753c.382.082.778-.063 1.013-.371v.02L11 9.456V17a1 1 0 102 0V9.254l2.4 2.352c.365.27.864.26 1.215-.012l.092-.08a.975.975 0 00.093-1.289l-4-3.943A1.095 1.095 0 0012 6z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
